export default __webpack_public_path__ + "static/media/BMMF-Phone03.c1df918f.webp";